import { useAuth } from "../../auth/hooks/useAuth";

export const useSchoolType = (): string => {
  const {
    profile: { data: { data: profile = null } = {} },
  } = useAuth();

  return profile?.school?.typeId ?? null;
};
